import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../ui/select';
import { Eye, MousePointerClick, ShoppingCart, XCircle, Loader2 } from 'lucide-react';
import api from '../../lib/api';

const Stat = ({ icon: Icon, label, value, sub, testid }) => (
    <div className="rounded-xl border border-neutral-200 p-5" data-testid={testid}>
        <div className="flex items-center gap-2 text-sm text-neutral-500"><Icon className="w-4 h-4" />{label}</div>
        <div className="text-3xl font-bold text-neutral-900 mt-2">{value}</div>
        {sub && <div className="text-xs text-neutral-500 mt-1">{sub}</div>}
    </div>
);

export const UpsellStatsPanel = () => {
    const [days, setDays] = useState('30');
    const [stats, setStats] = useState(null);

    useEffect(() => {
        setStats(null);
        api.get('/admin/upsell-stats', { params: { days } }).then(r => setStats(r.data)).catch(() => setStats({ error: true }));
    }, [days]);

    return (
        <Card data-testid="upsell-stats-panel">
            <CardHeader className="flex flex-row items-start justify-between gap-4">
                <div>
                    <CardTitle>Multi-Apply Pop-Up</CardTitle>
                    <CardDescription>How many members saw the "Let us apply for you" pop-up, clicked it, and went on to buy a plan.</CardDescription>
                </div>
                <Select value={days} onValueChange={setDays}>
                    <SelectTrigger className="w-40" data-testid="upsell-stats-range"><SelectValue /></SelectTrigger>
                    <SelectContent>
                        <SelectItem value="7">Last 7 days</SelectItem>
                        <SelectItem value="30">Last 30 days</SelectItem>
                        <SelectItem value="90">Last 90 days</SelectItem>
                        <SelectItem value="3650">All time</SelectItem>
                    </SelectContent>
                </Select>
            </CardHeader>
            <CardContent>
                {!stats ? <Loader2 className="w-6 h-6 animate-spin text-neutral-400" /> : stats.error ? (
                    <p className="text-sm text-rose-600">Could not load stats.</p>
                ) : (
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                        <Stat icon={Eye} label="Saw it" value={stats.shown.people} sub={`${stats.shown.total} ${stats.shown.total === 1 ? 'time' : 'times'} shown`} testid="upsell-stat-shown" />
                        <Stat icon={MousePointerClick} label="Clicked" value={stats.clicked.people} sub={`${stats.click_rate}% of viewers`} testid="upsell-stat-clicked" />
                        <Stat icon={ShoppingCart} label="Bought a plan" value={stats.purchased.people} sub={`${stats.purchase_rate}% of viewers · £${stats.purchased.revenue.toFixed(2)}`} testid="upsell-stat-purchased" />
                        <Stat icon={XCircle} label="Closed it" value={stats.dismissed.people} sub={`${stats.dismissed.total} ${stats.dismissed.total === 1 ? 'time' : 'times'}`} testid="upsell-stat-dismissed" />
                    </div>
                )}
            </CardContent>
        </Card>
    );
};
